<title mat-dialog-title>{{ 'auth.mouDialog.title' | t }}</title>
<mat-dialog-content (scroll)="onScroll($event)">
  <ng-template [ngIf]="mouThemplate">
    <div [innerHTML]="mouThemplate"></div>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [disabled]="buttonDisabled" color="success" (click)="aceptedMou()">
    {{ 'auth.cjisCompliance.agreeButton' | t }}
  </button>
  <button mat-button color="danger" (click)="close()">{{ 'common.close' | t }}</button>
  <span class="small-text">{{ 'auth.mouDialog.disclaimer' | t }}</span>
</mat-dialog-actions>
